import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false
};


const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    openCloseSideBar: (state) => {
      state.isOpen = !state.isOpen;
    }
  },
});

export const { openCloseSideBar } = sidebarSlice.actions;
export default sidebarSlice.reducer;